<template>
  <section class="pages-view">
    <div class="tab-container">
      <div class="tab-container__tabs">
        <router-link
          class="router-link"
          v-for="item in navigation.items"
          :key="item.title"
          :to="item.link"
        >
          <div class="tab-container__tabs__tab">
            <h2 class="h4">{{ item.title }}</h2>
          </div>
        </router-link>
      </div>
      <div class="tab-container__content">
        <transition name="component-fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      navigation: {
        items: [
          { title: "Overview", link: { name: "list-pages" } },
          { title: "Add new page +", link: { name: "new-page" } },
        ],
      },
    };
  },
};
</script>

<style scoped></style>
